import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";
import { buildUrl, redirectPayFip } from "./utils";
import validator from "validator";

function App() {
    const [formState, setFormState] = React.useState({
        refdet: '',
        mel: '',
        montant: '',
        name: '',
        prename: '',
        social: '',
    })
    const [errors, setErrors] = React.useState({});
    const [loader, setLoader] = React.useState(false);

    const handleInput = (e) => {
        setErrors({});
        setFormState({
            ...formState,
            [e.target.name]: e.target.name === "consent" ? e.target.checked : e.target.value
        });
    }

  
    const handleSubmit = (e) => {
        e.preventDefault();

        let formErrors = {};

        if (formState.refdet === '' || !validator.isLength(formState.refdet, { min: 2, max: 30 })) {
            formErrors['refdet'] = "Veuillez soumettre un numéro de facture valide entre 2 et 30 caractères";
        }

        if (formState.mel === '' || !validator.isEmail(formState.mel)) {
            formErrors['mel'] = "Veuillez soumettre un email valide";
        }

        if (formState.montant === '' || !validator.isNumeric(formState.montant)) {
            formErrors['montant'] = "Veuillez soumettre un montant valide";
        }

        if (formState.name === '' || !validator.isLength(formState.name, { min: 2, max: 30 })) {
            formErrors['name'] = "Veuillez soumettre un nom valide";
        }

        if (formState.prename === '' || !validator.isLength(formState.prename, { min: 2, max: 30 })) {
            formErrors['prename'] = "Veuillez soumettre un prénom valide";
        }

        if (formState.social === '' || !validator.isLength(formState.social, { min: 2, max: 30 })) {
            formErrors['social'] = "Veuillez soumettre une raison sociale valide"
        }

        if (formState.consent === '' || formState.consent === false) {
            formErrors['consent'] = "Vous devez cocher cette case";
        }


        setErrors({
            ...formErrors
        });


        let hasError = Object.keys(formErrors).length > 0;
        if (!hasError) {
            setLoader(true);
            buildUrl(formState).then((response ) => {
                let { data } = response;
                redirectPayFip(data);
            })
            .catch(err => {
                let errMsg = err.response.data;
                if (!errMsg) {
                    errMsg = "Une erreur est survenue, vérifier la validité des données";
                }
                setLoader(false);
                setErrors({
                    request: errMsg
                })
            })
        }
    }
    return (
        <div className="wrapper">
            <form onSubmit={handleSubmit} noValidate={true}>
                <div className={`container ${loader ? 'loading' : ''}`} >
                    <p className="invalid-feedback invalid-custom">{errors && errors.request}</p>
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-6">
                            <div className="input-group mb-3">
                                <input type="text" className="form-control border border-info" name="refdet" placeholder="Numéro de facture *" onChange={handleInput}  value={formState.refdet} required={true} />
                                <div className="invalid-feedback invalid-custom" style={{display: "block"}}>
                                    {errors && errors.refdet}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group mb-3">
                                <input type="text" className="form-control border border-info" name="montant" placeholder="Montant à payer *" onChange={handleInput} value={formState.montant} required={true} />
                                <div className="invalid-feedback invalid-custom">
                                    {errors && errors.montant}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group mb-3">
                                <input type="text" className="form-control border border-info" name="name" placeholder="Nom *" onChange={handleInput} value={formState.name} required={true} />
                                <div className="invalid-feedback invalid-custom">
                                    {errors && errors.name}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group mb-3">
                                <input type="text" className="form-control border border-info" name="prename" placeholder="Prénom *" onChange={handleInput} value={formState.prename} required={true} />
                                <div className="invalid-feedback invalid-custom">
                                    {errors && errors.prename}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group mb-3">
                                <input type="text" className="form-control border border-info" name="social" placeholder="Raison sociale *" value={formState.social} onChange={handleInput} required={true} />
                                <div className="invalid-feedback invalid-custom">
                                    {errors && errors.social}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group mb-3">
                                <input type="text" className="form-control border border-info" name="mel" placeholder="Email *" value={formState.email} onChange={handleInput} required={true} />
                                <div className="invalid-feedback invalid-custom">
                                    {errors && errors.mel}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="input-group mb-3 d-flex align-items-center">
                                <input type="checkbox" className="border border-info mt-1" name="consent" onChange={handleInput}  checked={formState.consent ? true : false} required={true} />
                                <div className="d-flex justify-content-between align-items-center w-100">
                                    <label htmlFor="consent" className="mx-2">
                                        <span>Je certifie l'exactitude des données ci-dessus et autorise le PAS à utiliser mes données pour traiter mon paiement</span>
                                        <div className="invalid-feedback invalid-custom">
                                            {errors && errors.consent}
                                        </div>
                                    </label>
                                    <button type="submit" className="btn btn-info mx-2">Envoyer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <p className="text-secondary">* Champs obligatoires</p>
        </div>
    );
}

export default App;
